import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import allDay from './allDay.js'
import attendee from './attendee/attendee.js'
import reminder from './reminder/reminder.js'
import repeat from './repeat/repeat.js'
import setEnd from './setEnd.js'

export default contract({
  allDay: array([
    allDay
  ]),
  attendee,
  reminder,
  repeat,
  setEnd: array([
    setEnd
  ]),
})
